import React from 'react';

import style from './style.module.css';
import { SimpleModal } from '../../../../../../components/simple-modal';

/**
 * @typedef {import('../../../../../../prop-types/intl').MessageDescriptorPropType} MessageDescriptorPropType
 * @param {object} props
 * @param {() => void} props.onClose
 * @param {() => void} [props.onAction]
 * @param {() => void} [props.onCancel]
 * @param {React.ReactNode} props.children
 * @param {MessageDescriptorPropType|string} [props.headerMessage]
 * @param {MessageDescriptorPropType|string} [props.cancelMessage]
 * @param {boolean} [props.isActionDisabled]
 * @param {MessageDescriptorPropType|string} [props.actionMessage]
 * @returns {JSX.Element}
 */
export const ManageModal = ({
  onCancel,
  onClose,
  onAction,
  children,
  actionMessage,
  cancelMessage,
  headerMessage,
  isActionDisabled = false,
}) => {
  return (
    <SimpleModal
      actionMessage={actionMessage}
      bodyClassName={style['manage-modal-body']}
      cancelMessage={cancelMessage}
      className={style['manage-modal']}
      headerMessage={headerMessage}
      isActionDisabled={isActionDisabled}
      onAction={onAction}
      onCancel={onCancel}
      onClose={onClose}
      size='custom'
    >
      {children}
    </SimpleModal>
  );
};
